import { Local } from 'sode-extend-react/sources/storage' 



/**
 * Calcula el monto total del carrito de compras considerando el precio base de los productos,
 * adicionales por personalizados (sabor de keke y relleno) y el descuento aplicable por puntos del usuario.
 *
 * @param {Array<Object>} cartItems - Array con los objetos de los productos actualmente en el carrito.
 * @param {number} cartItems[].precio - Precio unitario base del producto.
 * @param {number} cartItems[].cantidad - Cantidad seleccionada de dicho producto.
 * @param {number} [cartItems[].points] - Costo en puntos para canjear una unidad de este producto.
 * @param {boolean} [cartItems[].usePoints] - Indica si el usuario activó la opción de pagar este ítem con puntos.
 * @param {Object} [cartItems[].kekeSabor] - Objeto con la configuración del sabor del keke seleccionada.
 * @param {number} [cartItems[].kekeSabor.precio_adicional] - Monto extra a sumar por el sabor del keke.
 * @param {Object} [cartItems[].kekeRelleno] - Objeto con la configuración del relleno seleccionado.
 * @param {number} [cartItems[].kekeRelleno.precio_adicional] - Monto extra a sumar por el relleno.
 * 
 * @param {number} [points=0] - Saldo total de puntos disponibles que el usuario tiene para gastar.
 * 
 * @returns {number} El monto total calculado a pagar en moneda local.
 *
 * @example
 * const total = calculartotal(cartItems, 150);
 */
export const  calculartotal = (cartItems, points = 0) => {
  let articulos = cartItems

  let total = 0
  let restPoints = structuredClone(points)
  // let descuento = 0 

  

  for (const item of articulos) {
    let totalPrice = 0;

    const adicionalKeke = Number(item.kekeSabor?.precio_adicional || 0);
    const adicionalRelleno = Number(item.kekeRelleno?.precio_adicional || 0);
    
    

    let cantidadGeneral = structuredClone(item.cantidad)
    for (let i = 0; i < item.cantidad; i++) {
      if (restPoints >= item.points && item.usePoints) {
        
        restPoints -= item.points
        cantidadGeneral--
      } else break
    }
    totalPrice = cantidadGeneral * Number(item.precio);
    total += totalPrice + adicionalKeke + adicionalRelleno
  }
  // descuento= articulos[0].descuento ?? 0
  

  return total
}

export default calculartotal;